import { Link } from 'react-router-dom';

export default function CaseStudyCard({ study }) {
  const metrics = study.metrics || [];
  const topMetric = metrics[0];

  return (
    <Link to={`/case-studies/${study.slug}`} className="group block bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      {study.hero_image && (
        <div className="relative h-48 overflow-hidden">
          <img src={study.hero_image} alt={study.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          {topMetric && (
            <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-bold">
              {topMetric.value} {topMetric.label}
            </div>
          )}
        </div>
      )}
      <div className="p-6">
        <div className="text-sm text-blue-600 font-medium mb-1">{study.client_name}</div>
        <h3 className="text-xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">{study.title}</h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">{study.excerpt}</p>
        <div className="flex flex-wrap gap-2">
          {(study.technologies || []).slice(0, 4).map(t => (
            <span key={t} className="bg-gray-100 text-gray-700 text-xs font-medium px-2.5 py-0.5 rounded">{t}</span>
          ))}
        </div>
      </div>
    </Link>
  );
}
